








import { Component, Prop, Vue } from 'vue-property-decorator';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import * as esri from 'esri-leaflet';

@Component
export default class EmbeddedLeafletMap extends Vue {

    @Prop(String) public readonly height: string | undefined;
    @Prop(String) public readonly width: string | undefined;
    @Prop(String) public readonly geoJson: string | undefined;
    @Prop(String) public readonly geoJsonPID: string | undefined;
    @Prop(L.LatLngBounds) public readonly bounds: L.LatLngBounds | undefined;
    @Prop(String) public readonly popupName: string | undefined;
    @Prop(String) public readonly mode: string | undefined;

    get config() {
        return this.$store.state.config;
    }

    public parcelStyle = { color: '#DC1C2E', weight: 2, opacity: 0.85 };

    public createFilterMap() {
        const lSW: L.LatLngTuple = [this.config.mapDefault.maxBounds[0][0], this.config.mapDefault.maxBounds[0][1]];
        const lNE: L.LatLngTuple = [this.config.mapDefault.maxBounds[1][0], this.config.mapDefault.maxBounds[1][1]];
        const lMapOptions: L.MapOptions = {
            zoomControl: true,
            scrollWheelZoom: false,
            maxBounds: new L.LatLngBounds(lSW, lNE),
            minZoom: this.config.mapDefault.minZoom,
        };

        const lMap: L.Map = L.map('embeddedMap', lMapOptions).setView([44.68, -63.74], 10);
        esri.basemapLayer('Gray').addTo(lMap);
        if (this.geoJson) {
            const mapFeature = L.geoJSON(JSON.parse(this.geoJson)).addTo(lMap);
            lMap.fitBounds(mapFeature.getBounds());
            if (this.popupName && this.popupName.length > 0) {
                mapFeature.bindPopup('<b>' + this.popupName + '</b>').openPopup();
            }
        }
    }

    public createDemographicsMap() {

        const lSW: L.LatLngTuple = [this.config.mapDefault.maxBounds[0][0], this.config.mapDefault.maxBounds[0][1]];
        const lNE: L.LatLngTuple = [this.config.mapDefault.maxBounds[1][0], this.config.mapDefault.maxBounds[1][1]];
        const lMapOptions: L.MapOptions = {
            zoomControl: true,
            scrollWheelZoom: false,
            maxBounds: new L.LatLngBounds(lSW, lNE),
            minZoom: this.config.mapDefault.minZoom,
        };

        const lMap: L.Map = L.map('embeddedMap', lMapOptions).setView([44.68, -63.74], 10);
        esri.basemapLayer('Gray').addTo(lMap);
        if (this.geoJson && this.geoJsonPID && this.bounds) {
            const mapFeature = L.geoJSON(JSON.parse(this.geoJson)).addTo(lMap);
            const pidFeature = L.geoJSON(JSON.parse(this.geoJsonPID), {style: this.parcelStyle}).addTo(lMap);
            lMap.fitBounds(this.bounds);
        }
    }

    public mounted() {
        console.log('EmbeddedLeafletMap: mounted()');

        if (this.mode === 'Filter') {
            this.createFilterMap();
        } else if (this.mode === 'Demographics') {
            this.createDemographicsMap();
        }
    }
}
